import { CircularProgress, ThemeProvider, Typography } from '@mui/material';
import { Html, useProgress } from '@react-three/drei';
import { mainTheme } from '../../../../theme/mainTheme';

export function ThreeJsLoader() {
  const { progress } = useProgress();
  return (
    <Html center>
      <ThemeProvider theme={mainTheme}>
        <div style={{ position: 'relative', display: 'inline-flex' }}>
          <CircularProgress
            variant='determinate'
            value={progress}
            size={50}
            color='primary'
          />
          <div
            style={{
              top: 0,
              left: 0,
              bottom: 0,
              right: 0,
              position: 'absolute',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography
              fontSize='14px'
              fontWeight='bold'
              component='div'
            >{`${progress.toFixed(0)}%`}</Typography>
          </div>
        </div>
      </ThemeProvider>
    </Html>
  );
}
